import { EventPlace, trackEngagement } from "helpers/analytics";
import { TicketSilo } from "interfaces/entities/ticket";

export const trackTicketsSearchClearEvent = (source: "x in search field" | "empty state button"): void => {
  trackEngagement("Tickets: Search cleared", EventPlace.Tickets, { method: source });
};

export const trackSearchSiloTabOpenEvent = (tab: TicketSilo, searchQuery: string): void => {
  trackEngagement("Search: Silo tab opened", EventPlace.Tickets, {
    tab,
    searchQuery,
  });
};
